import { useMutation } from "@tanstack/react-query";
import { updateStaticTranslations } from "../api/updateStaticTranslations";
import { invalidateStaticTranslations } from "../queries/useStaticTranslations";
import { UpdatedTranslations } from "../types";

export const useStaticTranslationsMutation = () => {
  return useMutation({
    mutationFn: async (updatedTranslations: UpdatedTranslations) => {
      return await updateStaticTranslations(updatedTranslations);
    },
    onSuccess: () => {
      invalidateStaticTranslations();
    },
    onError: (e) => {
      console.error("Error occurred when updating static translations", e);
    },
  });
};
